import React, { Fragment, Component } from 'react'
import { VideoPlayer } from 'react-video-player'
import ClipsContainer from './ClipsContainer'
import { Container, Row, mediaDn, fontSize, spacer } from 'stylist'
import styled from 'react-emotion'

const VideoHeader = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  margin: ${spacer(6)} 0;

  > h3 {
    margin: 0;
    line-height: inherit;
  }

  a {
    &:first-letter {
      text-transform: uppercase;
    }
    ${fontSize('m')};
  }

  .only-tablet-up {
    ${mediaDn('md')} {
      display: none;
    }
  }
`

class VideoPlayerContainer extends Component {
  state = {
    duration: 0,
    currentTime: 0
  }

  videoPlayerRef = React.createRef()

  updateDuration(duration) {
    this.setState({ duration })
  }

  handleClipClick = clip =>
    this.videoPlayerRef.current.setTime(clip.startTime) ||
    this.videoPlayerRef.current.play()

  render() {
    const {
      clips,
      video: { feedback, url, title },
      show
    } = this.props

    const { duration } = this.state

    const clipsToShow = clips.filter(
      clip => clip.feedback == null || clip.feedback.positive
    )

    return (
      <Fragment>
        <Row>
          <Container>
            <VideoHeader>
              <h3>{title}</h3>
            </VideoHeader>

            <VideoPlayer
              onLoadedMetaData={() =>
                !duration &&
                this.updateDuration(this.videoPlayerRef.current.duration())
              }
              onTimeUpdate={() =>
                this.videoPlayerRef.current &&
                this.videoPlayerRef.current.currentTime() !==
                  this.state.currentTime &&
                this.setState({
                  currentTime: this.videoPlayerRef.current.currentTime()
                })
              }
              ref={this.videoPlayerRef}
              sources={[
                {
                  src: url,
                  type: 'video/mp4'
                }
              ]}
              plugins={{
                clipPlugin: {
                  clips: clipsToShow,
                  onClipsEnded: () => feedback || show()
                }
              }}
            />
          </Container>
        </Row>
        <Row>
          <Container>
            <ClipsContainer
              currentTime={this.state.currentTime}
              clips={clips}
              clipsToShow={clipsToShow}
              handleClipClick={clip => this.handleClipClick(clip)}
              duration={duration}
            />
          </Container>
        </Row>
      </Fragment>
    )
  }
}

export default VideoPlayerContainer



// WEBPACK FOOTER //
// ./src/routes/video/components/VideoPlayerContainer.js